import { MinusIcon, PlusIcon, TruckIcon } from '@heroicons/react/24/outline'

interface AmbulanceCounterProps {
  smur: number
  transport: number
  onUpdate: (type: 'smur' | 'transport', count: number) => void
}

export function AmbulanceCounter({ smur, transport, onUpdate }: AmbulanceCounterProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {([
        { type: 'smur' as const, label: 'SMUR', desc: 'Médicalisée', value: smur },
        { type: 'transport' as const, label: 'Transport', desc: 'Sanitaire', value: transport },
      ]).map(({ type, label, desc, value }) => (
        <div key={type} className="rounded-lg border border-neutral-200 bg-neutral-50 p-3 flex flex-col items-center gap-2">
          <TruckIcon className="w-5 h-5 text-neutral-500" />
          <span className="text-xs font-semibold text-neutral-700">{label}</span>
          <div className="flex items-center gap-1">
            <button
              type="button"
              onClick={() => onUpdate(type, Math.max(0, value - 1))}
              className="w-7 h-7 rounded border border-neutral-200 flex items-center justify-center text-neutral-500 hover:bg-white transition-colors"
            >
              <MinusIcon className="w-3.5 h-3.5" />
            </button>
            <span className="w-8 text-center text-lg font-bold tabular-nums text-neutral-900">{value}</span>
            <button
              type="button"
              onClick={() => onUpdate(type, value + 1)}
              className="w-7 h-7 rounded border border-neutral-200 flex items-center justify-center text-neutral-500 hover:bg-white transition-colors"
            >
              <PlusIcon className="w-3.5 h-3.5" />
            </button>
          </div>
          <span className="text-[10px] text-neutral-400">{desc}</span>
        </div>
      ))}
    </div>
  )
}
